import { render } from "./legoIconWrapper.vue?vue&type=template&id=71812d8b"
import script from "./legoIconWrapper.vue?vue&type=script&lang=js"
export * from "./legoIconWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoIcon/legoIconWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71812d8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71812d8b', __exports__)) {
    api.reload('71812d8b', __exports__)
  }
  
  module.hot.accept("./legoIconWrapper.vue?vue&type=template&id=71812d8b", () => {
    api.rerender('71812d8b', render)
  })

}


export default __exports__